import { isEmpty } from 'ramda';
import Utils from 'src/utils';

import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';
import { wtsApi } from 'src/api';
import { toastrNetworkError } from 'src/helpers/toastr/toastrNetworkResponse';


export const UPLOAD_EMPLOYEES_EXCEL_REQUEST = 'UPLOAD_EMPLOYEES_EXCEL_REQUEST';
export const UPLOAD_EMPLOYEES_EXCEL_SUCCESS = 'UPLOAD_EMPLOYEES_EXCEL_SUCCESS';
export const UPLOAD_EMPLOYEES_EXCEL_FAIL = 'UPLOAD_EMPLOYEES_EXCEL_FAIL';

export const UPLOAD_CONTRACTS_EXCEL_REQUEST = 'UPLOAD_CONTRACTS_EXCEL_REQUEST';
export const UPLOAD_CONTRACTS_EXCEL_SUCCESS = 'UPLOAD_CONTRACTS_EXCEL_SUCCESS';
export const UPLOAD_CONTRACTS_EXCEL_FAIL = 'UPLOAD_CONTRACTS_EXCEL_FAIL';

export const LOAD_EMPLOYEES_REQUEST = 'LOAD_EMPLOYEES_REQUEST';
export const LOAD_EMPLOYEES_FAIL = 'LOAD_EMPLOYEES_FAIL';
export const LOAD_EMPLOYEES_SUCCESS = 'LOAD_EMPLOYEES_SUCCESS';

export const LOAD_ALL_EMPLOYEES_REQUEST = 'LOAD_ALL_EMPLOYEES_REQUEST';
export const LOAD_ALL_EMPLOYEES_FAIL = 'LOAD_ALL_EMPLOYEES_FAIL';
export const LOAD_ALL_EMPLOYEES_SUCCESS = 'LOAD_ALL_EMPLOYEES_SUCCESS';

export const LOAD_ALL_FULL_INFO_EMPLOYEES_REQUEST = 'LOAD_ALL_FULL_INFO_EMPLOYEES_REQUEST';
export const LOAD_ALL_FULL_INFO_EMPLOYEES_SUCCESS = 'LOAD_ALL_FULL_INFO_EMPLOYEES_SUCCESS';
export const LOAD_ALL_FULL_INFO_EMPLOYEES_FAIL = 'LOAD_ALL_FULL_INFO_EMPLOYEES_FAIL';

export const OPTIONS_SUCCESS = 'LOAD_EMPLOYEES_OPTIONS_SUCCESS';

export const LOAD_USER_INFO_REQUEST = 'LOAD_EMPLOYEE_INFO_REQUEST';
export const LOAD_USER_INFO_FAIL = 'LOAD_EMPLOYEE_INFO_FAIL';
export const LOAD_USER_INFO_SUCCESS = 'LOAD_EMPLOYEE_INFO_SUCCESS';

export const RESET_EMPLOYEE_DATA = 'RESET_EMPLOYEE_DATA';
export const RESET_USER_INFO = 'RESET_USER_INFO';

export const LOAD_CONTRACT_TYPE_REQUEST = 'LOAD_CONTRACT_TYPE_REQUEST';
export const LOAD_CONTRACT_TYPE_FAIL = 'LOAD_CONTRACT_TYPE_FAIL';
export const LOAD_CONTRACT_TYPE_SUCCESS = 'LOAD_CONTRACT_TYPE_SUCCESS';
export const LOAD_CONTRACT_TYPE_OPTIONS_SUCCESS = 'LOAD_CONTRACT_TYPE_OPTIONS_SUCCESS';

export const LOAD_WORK_GROUP_REQUEST = 'LOAD_WORK_GROUP_REQUEST';
export const LOAD_WORK_GROUP_FAIL = 'LOAD_WORK_GROUP_FAIL';
export const LOAD_WORK_GROUP_SUCCESS = 'LOAD_WORK_GROUP_SUCCESS';

export const LOAD_CARD_TYPES_REQUEST = 'LOAD_CARD_TYPES_REQUEST';
export const LOAD_CARD_TYPES_FAIL = 'LOAD_CARD_TYPES_FAIL';
export const LOAD_CARD_TYPES_SUCCESS = 'LOAD_CARD_TYPES_SUCCESS';

export const POST_USER_JOB_REQUEST = 'POST_USER_JOB_REQUEST';
export const POST_USER_JOB_FAIL = 'POST_USER_JOB_FAIL';
export const POST_USER_JOB_SUCCESS = 'POST_USER_JOB_SUCCESS';

export const POST_USER_JOBS_MULTIPLE_REQUEST = 'POST_USER_JOBS_MULTIPLE_REQUEST';
export const POST_USER_JOBS_MULTIPLE_FAIL = 'POST_USER_JOBS_MULTIPLE_FAIL';
export const POST_USER_JOBS_MULTIPLE_SUCCESS = 'POST_USER_JOBS_MULTIPLE_SUCCESS';

export const PUT_USER_JOB_REQUEST = 'PUT_USER_JOB_REQUEST';
export const PUT_USER_JOB_FAIL = 'PUT_USER_JOB_FAIL';
export const PUT_USER_JOB_SUCCESS = 'PUT_USER_JOB_SUCCESS';

export const POST_USER_REQUEST = 'POST_USER_REQUEST';
export const POST_USER_FAIL = 'POST_USER_FAIL';
export const POST_USER_SUCCESS = 'POST_USER_SUCCESS';

export const DELETE_USER_JOB_REQUEST = 'DELETE_USER_JOB_REQUEST';
export const DELETE_USER_JOB_FAIL = 'DELETE_USER_JOB_FAIL';
export const DELETE_USER_JOB_SUCCESS = 'DELETE_USER_JOB_SUCCESS';

export const DELETE_USER_JOBS_MULTIPLE_REQUEST = 'DELETE_USER_JOBS_MULTIPLE_REQUEST';
export const DELETE_USER_JOBS_MULTIPLE_FAIL = 'DELETE_USER_JOBS_MULTIPLE_FAIL';
export const DELETE_USER_JOBS_MULTIPLE_SUCCESS = 'DELETE_USER_JOBS_MULTIPLE_SUCCESS';

export const POST_USER_CARD_REQUEST = 'POST_USER_CARD_REQUEST';
export const POST_USER_CARD_FAIL = 'POST_USER_CARD_FAIL';
export const POST_USER_CARD_SUCCESS = 'POST_USER_CARD_SUCCESS';

export const DELETE_USER_CARD_REQUEST = 'DELETE_USER_CARD_REQUEST';
export const DELETE_USER_CARD_FAIL = 'DELETE_USER_CARD_FAIL';
export const DELETE_USER_CARD_SUCCESS = 'DELETE_USER_CARD_SUCCESS';

export const SHOW_USER_CARD_INFO = 'SHOW_USER_CARD_INFO';
export const HIDE_USER_CARD_INFO = 'HIDE_USER_CARD_INFO';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const DELETE_USER_PHOTO_REQUEST = 'DELETE_USER_PHOTO_REQUEST';
export const DELETE_USER_PHOTO_FAIL = 'DELETE_USER_PHOTO_FAIL';
export const DELETE_USER_PHOTO_SUCCESS = 'DELETE_USER_PHOTO_SUCCESS';

export const PUT_USER_REQUEST = 'PUT_USER_REQUEST';
export const PUT_USER_SUCCESS = 'PUT_USER_SUCCESS';
export const PUT_USER_FAIL = 'PUT_USER_FAIL';

export const PUT_USERS_MULTIPLE_REQUEST = 'PUT_USERS_MULTIPLE_REQUEST';
export const PUT_USERS_MULTIPLE_SUCCESS = 'PUT_USERS_MULTIPLE_SUCCESS';
export const PUT_USERS_MULTIPLE_FAIL = 'PUT_USERS_MULTIPLE_FAIL';

export const POST_USER_SKILL_REQUEST = 'POST_USER_SKILL_REQUEST';
export const POST_USER_SKILL_SUCCESS = 'POST_USER_SKILL_SUCCESS';
export const POST_USER_SKILL_FAIL = 'POST_USER_SKILL_FAIL';

export const PUT_USER_SKILL_REQUEST = 'PUT_USER_SKILL_REQUEST';
export const PUT_USER_SKILL_SUCCESS = 'PUT_USER_SKILL_SUCCESS';
export const PUT_USER_SKILL_FAIL = 'PUT_USER_SKILL_FAIL';

export const DELETE_USER_SKILL_REQUEST = 'DELETE_USER_SKILL_REQUEST';
export const DELETE_USER_SKILL_SUCCESS = 'DELETE_USER_SKILL_SUCCESS';
export const DELETE_USER_SKILL_FAIL = 'DELETE_USER_SKILL_FAIL';

export const GENERATE_WEB_USERS_REQUEST = 'GENERATE_WEB_USERS_REQUEST';
export const GENERATE_WEB_USERS_SUCCESS = 'GENERATE_WEB_USERS_SUCCESS';
export const GENERATE_WEB_USERS_FAIL = 'GENERATE_WEB_USERS_FAIL';

export const PUT_USER_BACK_FROM_ARCHIVE_SUCCESS = 'PUT_USER_BACK_FROM_ARCHIVE_SUCCESS';

const loadEmployeesRequest = () => ({ type: LOAD_EMPLOYEES_REQUEST });
const loadEmployeesFail = (err) => ({ type: LOAD_EMPLOYEES_FAIL, err });
const loadEmployeesSuccess = (data) => ({ type: LOAD_EMPLOYEES_SUCCESS, data });

const uploadEmployeesExcelRequest = () => ({ type: UPLOAD_EMPLOYEES_EXCEL_REQUEST });
const uploadEmployeesExcelSuccess = (data) => ({ type: UPLOAD_EMPLOYEES_EXCEL_SUCCESS, data });
const uploadEmployeesExcelFail = (err) => ({ type: UPLOAD_EMPLOYEES_EXCEL_FAIL, err });

const uploadContractsExcelRequest = () => ({ type: UPLOAD_CONTRACTS_EXCEL_REQUEST });
const uploadContractsExcelSuccess = (data) => ({ type: UPLOAD_CONTRACTS_EXCEL_SUCCESS, data });
const uploadContractsExcelFail = (err) => ({ type: UPLOAD_CONTRACTS_EXCEL_FAIL, err });

export const loadAllEmployeesRequest = () => ({ type: LOAD_ALL_EMPLOYEES_REQUEST });
export const loadAllEmployeesFail = (err) => ({ type: LOAD_ALL_EMPLOYEES_FAIL, err });
export const loadAllEmployeesSuccess = (data) => ({ type: LOAD_ALL_EMPLOYEES_SUCCESS, data });

export const loadAllFullInfoEmployeesRequest = () => ({ type: LOAD_ALL_FULL_INFO_EMPLOYEES_REQUEST });
export const loadAllFullInfoEmployeesFail = (err) => ({ type: LOAD_ALL_FULL_INFO_EMPLOYEES_FAIL, err });
export const loadAllFullInfoEmployeesSuccess = (data) => ({ type: LOAD_ALL_FULL_INFO_EMPLOYEES_SUCCESS, data });

const loadContractTypeRequest = () => ({ type: LOAD_CONTRACT_TYPE_REQUEST });
const loadContractTypeFail = (err) => ({ type: LOAD_CONTRACT_TYPE_FAIL, err });
const loadContractTypeSuccess = (data) => ({ type: LOAD_CONTRACT_TYPE_SUCCESS, data });
const loadContractTypeOptionsSuccess = (data) => ({ type: LOAD_CONTRACT_TYPE_OPTIONS_SUCCESS, data });

const loadCardTypesRequest = () => ({ type: LOAD_CARD_TYPES_REQUEST });
const loadCardTypesFail = (err) => ({ type: LOAD_CARD_TYPES_FAIL, err });
const loadCardTypesSuccess = (data) => ({ type: LOAD_CARD_TYPES_SUCCESS, data });

const postUserJobRequest = () => ({ type: POST_USER_JOB_REQUEST });
const postUserJobSuccess = (userJob) => ({ type: POST_USER_JOB_SUCCESS, userJob });
const postUserJobFail = (error) => ({ type: POST_USER_JOB_FAIL, error });

const postUserJobsMultipleRequest = () => ({ type: POST_USER_JOBS_MULTIPLE_REQUEST });
const postUserJobsMultipleSuccess = (userJobs) => ({ type: POST_USER_JOBS_MULTIPLE_SUCCESS, userJobs });
const postUserJobsMultipleFail = (error) => ({ type: POST_USER_JOBS_MULTIPLE_FAIL, error });

const putUserJobRequest = () => ({ type: PUT_USER_JOB_REQUEST });
const putUserJobSuccess = (userJob) => ({ type: PUT_USER_JOB_SUCCESS, userJob });
const putUserJobFail = (error) => ({ type: PUT_USER_JOB_FAIL, error });

const deleteUserJobRequest = () => ({ type: DELETE_USER_JOB_REQUEST });
const deleteUserJobSuccess = (userJob) => ({ type: DELETE_USER_JOB_SUCCESS, userJob });
const deleteUserJobFail = (error) => ({ type: DELETE_USER_JOB_FAIL, error });

const deleteUserJobsMultipleRequest = () => ({ type: DELETE_USER_JOBS_MULTIPLE_REQUEST });
const deleteUserJobsMultipleSuccess = (userJobs) => ({ type: DELETE_USER_JOBS_MULTIPLE_SUCCESS, userJobs });
const deleteUserJobsMultipleFail = (error) => ({ type: DELETE_USER_JOBS_MULTIPLE_FAIL, error });

const postUserCardRequest = () => ({ type: POST_USER_CARD_REQUEST });
const postUserCardSuccess = (userCard) => ({ type: POST_USER_CARD_SUCCESS, userCard });
const postUserCardFail = (error) => ({ type: POST_USER_CARD_FAIL, error });

const deleteUserCardRequest = () => ({ type: DELETE_USER_CARD_REQUEST });
const deleteUserCardSuccess = (userCard) => ({ type: DELETE_USER_CARD_SUCCESS, userCard });
const deleteUserCardFail = (error) => ({ type: DELETE_USER_CARD_FAIL, error });

const showUserCardInfo = (info) => ({ type: SHOW_USER_CARD_INFO, info });

const postUserRequest = () => ({ type: POST_USER_REQUEST });
const postUserSuccess = (user) => ({ type: POST_USER_SUCCESS, user });
const postUserFail = (error) => ({ type: POST_USER_FAIL, error });

const deleteUserRequest = () => ({ type: DELETE_USER_REQUEST });
const deleteUserSuccess = (userId) => ({ type: DELETE_USER_SUCCESS, userId });
const deleteUserFail = (error) => ({ type: DELETE_USER_FAIL, error });

const deleteUserPhotoRequest = () => ({ type: DELETE_USER_PHOTO_REQUEST });
const deleteUserPhotoSuccess = (userId) => ({ type: DELETE_USER_PHOTO_SUCCESS, userId });
const deleteUserPhotoFail = (error) => ({ type: DELETE_USER_PHOTO_FAIL, error });

const putUserSuccess = (user) => ({ type: PUT_USER_SUCCESS, user });
const putUserRequest = () => ({ type: PUT_USER_REQUEST });
const putUserFail = (error) => ({ type: PUT_USER_FAIL, error });

const putUsersMultipleSuccess = (user) => ({ type: PUT_USERS_MULTIPLE_SUCCESS, user });
const putUsersMultipleRequest = () => ({ type: PUT_USERS_MULTIPLE_REQUEST });
const putUsersMultipleFail = () => ({ type: PUT_USERS_MULTIPLE_FAIL });

const postUserSkillRequest = () => ({ type: POST_USER_SKILL_REQUEST });
const postUserSkillSuccess = (skill) => ({ type: POST_USER_SKILL_SUCCESS, skill });
const postUserSkillFail = () => ({ type: POST_USER_SKILL_FAIL });

const putUserSkillRequest = () => ({ type: PUT_USER_SKILL_REQUEST });
const putUserSkillSuccess = (skill) => ({ type: PUT_USER_SKILL_SUCCESS, skill });
const putUserSkillFail = () => ({ type: PUT_USER_SKILL_FAIL });

const deleteUserSkillRequest = () => ({ type: DELETE_USER_SKILL_REQUEST });
const deleteUserSkillSuccess = (skill) => ({ type: DELETE_USER_SKILL_SUCCESS, skill });
const deleteUserSkillFail = () => ({ type: DELETE_USER_SKILL_FAIL });

const generateWebUsersRequest = () => ({ type: GENERATE_WEB_USERS_REQUEST });
const generateWebUsersSuccess = (skill) => ({ type: GENERATE_WEB_USERS_SUCCESS, skill });
const generateWebUsersFail = () => ({ type: GENERATE_WEB_USERS_FAIL });

const putUserBackFromArchiveSuccess = (user) => ({ type: PUT_USER_BACK_FROM_ARCHIVE_SUCCESS, user });

const loadEmployeesOptionsSuccess = (employees) => ({ type: OPTIONS_SUCCESS, employees });

// eslint-disable-next-line max-len
const reformatContractTypesToOptions = (data) => data.map(({ ContractTypeId, ContractTypeName }) => ({ label: ContractTypeName, value: `${ContractTypeId}` }));

const EMPTY_ARRAY = [];

export const generateWebUsers = (params) => (dispatch) => {
  dispatch(generateWebUsersRequest());
  return communicate({
    url: 'Users/AddWebUsers',
    method: 'post',
    data: params
  }).then((response) => {
    toastrSuccess(response);
    dispatch(generateWebUsersSuccess(response.data.Data));
    return ({ res: response.data.Data });
  }).catch((err) => {
    dispatch(generateWebUsersFail(err));
    toastrError(err);
    return ({ err });
  });
};

export function reformatForOptionsMenu(data, withDeleted = false) {
  return data.reduce((acc, user) => {
    if (withDeleted || !user.IsDeleted) {
      acc.push({
        value: user.UserId.toString(),
        label: `${user.LastName} ${user.FirstName}`,
        externalCode: user.ExternalCode
      });
    }
    return acc;
  }, []);
}

export const requestEmployees = (params = {}) => communicate({
  url: 'Users',
  method: 'get',
  getParams: Utils.objects.getQueryStringFromObject(params)
})
  .then((response) => response.data.Data);

const loadEmployeesList = (params) => (dispatch) => {
  dispatch(loadEmployeesRequest());
  return requestEmployees(params)
    .then((data) => {
      dispatch(loadEmployeesSuccess(data));
    }).catch((err) => {
      dispatch(loadEmployeesFail(err));
      toastrError(err);
    });
};

const loadAllEmployeesList = () => (dispatch) => {
  dispatch(loadAllEmployeesRequest());
  return requestEmployees()
    .then((data) => {
      dispatch(loadAllEmployeesSuccess(data));
      dispatch(loadEmployeesOptionsSuccess(reformatForOptionsMenu(data)));
    }).catch((err) => {
      dispatch(loadAllEmployeesFail(err));
      toastrError(err);
    });
};

export const loadAllFullInfoEmployeesList = (params = {}) => (dispatch) => {
  dispatch(loadAllFullInfoEmployeesRequest());
  return communicate({ url: 'Users/GetFullInfo', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      dispatch(loadAllFullInfoEmployeesSuccess(data.Data));
    }).catch((err) => {
      dispatch(loadAllFullInfoEmployeesFail(err));
      toastrError(err);
    });
};

export const loadEmployees = (params) => (dispatch) => {
  if (params && !isEmpty(params)) {
    dispatch(loadEmployeesList(params));
  } else {
    dispatch(loadAllEmployeesList());
  }
};

export const loadEmployeesPromise = (params) => (dispatch) => {
  if (params && !isEmpty(params)) {
    return dispatch(loadEmployeesList(params));
  } else {
    return dispatch(loadAllEmployeesList());
  }
};

export const loadEmployeeIds = async (...args) => { // EmployeeFeatureSearchQuery
  try {
    const response = await wtsApi.v2.employeeSearchCreate(...args);
    return response.data.Data?.UserIds || EMPTY_ARRAY;
  } catch (err) {
    toastrNetworkError(err);
    return EMPTY_ARRAY;
  }
};

export const loadContractType = () => (dispatch) => {
  dispatch(loadContractTypeRequest());
  return communicate({ url: 'ContractTypes', method: 'get' }).then((response) => {
    dispatch(loadContractTypeSuccess(response.data.Data));
    dispatch(loadContractTypeOptionsSuccess(reformatContractTypesToOptions(response.data.Data)));
  }).catch((err) => {
    dispatch(loadContractTypeFail(err));
    toastrError(err);
  });
};

export const loadCardTypes = () => (dispatch) => {
  dispatch(loadCardTypesRequest());
  return communicate({ url: 'CardTypes', method: 'get' }).then((response) => {
    dispatch(loadCardTypesSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(loadCardTypesFail(err));
    toastrError(err);
  });
};

export const getUserJob = (params) => (dispatch) => communicate({
  url: 'JobUser',
  method: 'get',
  getParams: Utils.objects.objectToQueryString(params)
})
  .then((response) => Promise.resolve(response.data.Data))
  .catch((err) => {
    toastrError(err);
    return Promise.reject();
  });

export const postUserJob = (params) => (dispatch) => {
  dispatch(postUserJobRequest());
  return communicate({
    url: 'JobUser',
    method: 'post',
    data: params
  }).then((response) => {
    toastrSuccess(response);
    dispatch(postUserJobSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(postUserJobFail(err));
    toastrError(err);
  });
};

export const fetchPostUserJobsMultiple = (params) => communicate({
  url: 'JobUser/Multiple',
  method: 'post',
  data: params
});

export const postUserJobsMultiple = (params) => (dispatch) => {
  dispatch(postUserJobsMultipleRequest());
  return fetchPostUserJobsMultiple(params).then((response) => {
    toastrSuccess(response);
    dispatch(postUserJobsMultipleSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(postUserJobsMultipleFail(err));
    toastrError(err);
  });
};

export const putUserJob = (params) => (dispatch) => {
  dispatch(putUserJobRequest());
  return communicate({
    url: 'JobUser',
    method: 'put',
    data: params
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putUserJobSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(putUserJobFail(err));
    toastrError(err);
  });
};

export const deleteUserJob = (params) => (dispatch) => {
  dispatch(deleteUserJobRequest(params.jobId));
  return communicate({
    url: 'JobUser',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteUserJobSuccess(params));
    }).catch((err) => {
      dispatch(deleteUserJobFail(err));
      toastrError(err);
    });
};

export const fetchDeleteUserJobsMultiple = (params) => communicate({
  url: 'JobUser/Multiple',
  method: 'delete',
  getParams: Utils.objects.getQueryStringFromObject(params)
});

export const deleteUserJobsMultiple = (params) => (dispatch) => {
  dispatch(deleteUserJobsMultipleRequest(params.jobId));
  return fetchDeleteUserJobsMultiple(params)
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteUserJobsMultipleSuccess(params));
    }).catch((err) => {
      dispatch(deleteUserJobsMultipleFail(err));
      toastrError(err);
    });
};

export const postUserCard = (params) => (dispatch) => {
  dispatch(postUserCardRequest());
  return communicate({
    url: 'Cards',
    method: 'post',
    data: params // `?userId=${params.UserId}&cardTypeId=${params.CardTypeId}&cardNumber=${params.CardNumber}`,
  }).then(({ data }) => {
    toastrSuccess(data);
    if (data.ResultId > 0) {
      dispatch(showUserCardInfo({ title: data.ResultMsg, list: data.DeviceResults.Results }));
    }
    dispatch(postUserCardSuccess(data.Data));
  }).catch((err) => {
    dispatch(postUserCardFail(err));
    toastrError(err);
  });
};

export const deleteUserCard = (params) => (dispatch) => {
  dispatch(deleteUserCardRequest(params.jobId));
  return communicate({ url: 'Cards', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data }) => {
      toastrSuccess(data);
      if (data.ResultId > 0) {
        dispatch(showUserCardInfo({ title: data.ResultMsg, list: data.DeviceResults.Results }));
      }
      dispatch(deleteUserCardSuccess(params));
    }).catch((err) => {
      dispatch(deleteUserCardFail(err));
      toastrError(err);
    });
};

export const postUser = (params) => (dispatch) => {
  dispatch(postUserRequest());
  return communicate({
    url: 'Users',
    method: 'post',
    data: params
  }).then((response) => {
    toastrSuccess(response);
    return dispatch(postUserSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(postUserFail(err));
    toastrError(err);
  });
};

export const deleteUser = (params) => (dispatch) => {
  dispatch(deleteUserRequest());
  return communicate({ url: 'Users', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) }).then((response) => {
    dispatch(deleteUserSuccess(params.id));
    toastrSuccess(response);
  }).catch((err) => {
    dispatch(deleteUserFail(err));
    toastrError(err);
  });
};

export const postUserPhoto = (userId, formData) => {
  return communicate({
    url: 'Users/Pictures',
    method: 'post',
    data: formData,
    getParams: Utils.objects.getQueryStringFromObject({ userId }),
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deleteUserPhoto = (params) => (dispatch) => {
  dispatch(deleteUserPhotoRequest());
  return communicate({
    url: 'Users/Pictures',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(params)
  }).then((response) => {
    dispatch(deleteUserPhotoSuccess(params.id));
    toastrSuccess(response);
  }).catch((err) => {
    dispatch(deleteUserPhotoFail(err));
    toastrError(err);
  });
};

export const putUser = (params) => (dispatch) => {
  dispatch(putUserRequest());
  return communicate({
    url: 'Users',
    method: 'put',
    data: params
  }).then((response) => {
    dispatch(putUserSuccess(response.data.Data));
    toastrSuccess(response);
  }).catch((err) => {
    console.log(err);
    dispatch(putUserFail(err));
    toastrError(err);
  });
};

export const putUserBackFromArchive = (params) => (dispatch) => {
  dispatch(putUserRequest());
  return communicate({
    url: 'Users',
    method: 'put',
    data: params
  }).then((response) => {
    dispatch(putUserBackFromArchiveSuccess(response.data.Data));
    toastrSuccess(response);
  }).catch((err) => {
    dispatch(putUserFail(err));
    toastrError(err);
  });
};

export const storeExcelData = (cacheId) => (dispatch) => {
  dispatch(uploadEmployeesExcelRequest());
  return communicate({
    url: 'Imports/StoreUserExcel',
    method: 'post',
    data: { cacheId }
  }).then(({ data }) => {
    dispatch(uploadEmployeesExcelSuccess());
    toastrSuccess(data);
  }).catch((err) => {
    dispatch(uploadEmployeesExcelFail(err));
    toastrError(err);
  });
};

export const storeContractExcelData = (cacheId) => (dispatch) => {
  dispatch(uploadContractsExcelRequest());
  return communicate({
    url: 'Imports/StoreContractExcel',
    method: 'post',
    data: { cacheId }
  }).then(({ data }) => {
    dispatch(uploadContractsExcelSuccess());
    toastrSuccess(data);
  }).catch((err) => {
    dispatch(uploadContractsExcelFail(err));
    toastrError(err);
  });
};

export const putUsersMultiple = (data) => (dispatch) => {
  dispatch(putUsersMultipleRequest());
  return communicate({
    url: 'Users/Multiple',
    method: 'put',
    data
  }).then((response) => {
    dispatch(putUsersMultipleSuccess(response.data.Data));
    toastrSuccess(response);
  }).catch((err) => {
    dispatch(putUsersMultipleFail(err));
    toastrError(err);
  });
};


export const loadUserSkills = (params) => communicate({
  url: 'UserSkills',
  getParams: Utils.objects.getQueryStringFromObject(params)
});


export const postUserSkill = (params) => (dispatch) => {
  dispatch(postUserSkillRequest());
  return communicate({
    url: 'UserSkills',
    method: 'post',
    data: params
  }).then((response) => {
    toastrSuccess(response);
    dispatch(postUserSkillSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(postUserSkillFail(err));
    toastrError(err);
  });
};

export const putUserSkill = (params) => (dispatch) => {
  dispatch(putUserSkillRequest());
  return communicate({
    url: 'UserSkills',
    method: 'put',
    data: params
  }).then((response) => {
    toastrSuccess(response);
    dispatch(putUserSkillSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(putUserSkillFail(err));
    toastrError(err);
  });
};

export const deleteUserSkill = (params) => (dispatch) => {
  dispatch(deleteUserSkillRequest(params.jobId));
  return communicate({
    url: 'UserSkills',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteUserSkillSuccess(params));
    }).catch((err) => {
      dispatch(deleteUserSkillFail(err));
      toastrError(err);
    });
};

export const resetSelectedUser = () => (dispatch) => dispatch({ type: RESET_USER_INFO });

export const employeeSearch = (params) => {
  return wtsApi.v2.employeeSearchCreate(params)
    .then(({ data }) => {
      return data.Data.UserIds || [];
    })
    .catch((err) => {
      toastrError(err);
      return [];
    });
};